/* global yaCounter84617740 */
import vars from './globals.js';
import scrollDepth from 'scroll-depth';
import router from './router';

const clienLinks = ['https://www.ozon.ru/travel/corporate/?utm_source=rbk&utm_medium=social&utm_campaign=oztravel_210902_article_logo&utm_content=ozon_link_corporate', 'https://www.ozon.ru/travel/corporate/?utm_source=rbk&utm_medium=social&utm_campaign=oztravel_210902_article_how_leads_save_money&utm_content=ozon_link_corporate'];

function clearText(text) {
	return text.trim().replace(/\s+/g, ' ');
}

function isClientLink(href) {
	let value = false;

	clienLinks.forEach((link) => {
		if (href.indexOf(link) >= 0) {
			value = true;
		}
	});

	return value;
}

// /* Клик по ссылкам в статье на сайт клиента в карточке отзыва */
$('.article .article__text a').on('click', (e) => {
	const link = e.currentTarget.href;
	const name = e.currentTarget.textContent;
	const chekClientLink = isClientLink(link);

	if (chekClientLink) {
		ga('send', 'event', 'client link', 'article text link', name);
		ga('rbcspec.send', 'event', 'client link', 'click');
	} else {
		ga('send', 'event', 'article', 'article text link', name);
	}
});
$('.cards a').on('click', (e) => {
	const link = e.currentTarget.href;
	const name = e.currentTarget.textContent;
	const chekClientLink = isClientLink(link);

	if (chekClientLink) {
		ga('send', 'event', 'client link', 'cards text link', name);
		ga('rbcspec.send', 'event', 'client link', 'click');
	} else {
		ga('send', 'event', 'cards', 'cards text link', name);
	}
});

$('.article-info__description a').on('click', () => {
	ga('send', 'event', 'prodano', 'article click');
});

$('.footer__text a').on('click', (e) => {
	if (!$(e.currentTarget).hasClass('is-article')) {
		ga('send', 'event', 'prodano', 'main click');
	} else {
		ga('send', 'event', 'prodano', 'article click');
	}
});

function start15SecTimeout() {
	clearTimeout($(window).data('timeout15Sec'));

	vars.$window.data('timeout15Sec', setTimeout(() => {
		ga('rbcspec.send', 'event', 'page', 'spent_on_page_15_sec');
		ga('send', 'event', 'page', 'spent_on_page_15_sec');
	}, 15000));
}

function virtualHit(path) {
	if (window.ga) {
		ga('set', 'page', path);
		ga('send', 'pageview', path);
		ga('rbcspec.set', 'page', path);
		ga('rbcspec.send', 'pageview', path);
	}

	if (window.yaCounter84617740) {
		yaCounter84617740.hit(path);
	}
}

scrollDepth({
	userTiming: false,
	pixelDepth: false,
	gtmOverride: true,
	eventHandler(data) {
		ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
		ga('rbcspec.send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
	},
});

router.on('enter', (prevState, currentState) => {
	return new Promise((resolve) => {
		start15SecTimeout();

		if (prevState.route && currentState.route) {
			virtualHit(currentState.route.generatePath({params: currentState.params}) + location.search);

			jQuery.scrollDepth.reset();
		}

		resolve();
	});
});

const checkCardsPosition = (cards) => {
	let scrollTop = $(window).scrollTop();

	let scrollBottom = scrollTop + $(window).height();

	cards.each((i, card) => {
		let $card = $(card);

		let cardScrollTop = $card.offset().top;

		let cardScrollBottom = cardScrollTop + $card.height();

		let cardWasShow = false || $card.data('isShow');

		if (cardScrollTop < scrollBottom && cardScrollBottom > scrollTop && !cardWasShow) {
			const num = $card.find('.cards__title').text();

			ga('send', 'event', 'cards', 'show', `${num}`, {nonInteraction: true});

			$card.data('isShow', true);
		}
	});
};

const checkBannersPosition = (banners) => {
	let scrollTop = $(window).scrollTop();

	let scrollBottom = scrollTop + $(window).height();

	banners.each((i, banner) => {
		let $banner = $(banner);

		let bannerScrollTop = $banner.offset().top;

		let bannerScrollBottom = bannerScrollTop + $banner.height();

		let bannerWasShow = false || $banner.data('isShow');

		if (bannerScrollTop < scrollBottom && bannerScrollBottom > scrollTop && !bannerWasShow) {
			let type = $banner.data('box');
			let bannerName = $banner.attr('alt');

			ga('send', 'event', 'banner', 'show', `${type} banner - ${bannerName}`, {nonInteraction: true});

			$banner.data('isShow', true);
		}
	});
};

const $cards = $('.cards .cards__item');
const $banners = $('.box');

$(window).scroll(() => {
	checkCardsPosition($cards);

	checkBannersPosition($banners);
});

vars.$html.on('enterPage', () => {
	checkCardsPosition($cards);

	checkBannersPosition($banners);
});

$('.header__part--fixed a').on('click', () => {
	ga('send', 'event', 'nav', 'rbc topline link');
});

$('.home .card').on('click', (e) => {
	const name = clearText($(e.currentTarget).find('.card__title').text());

	ga('send', 'event', 'main', 'material click', `${name}`);
});

/* Клик на раскрывашку в карточке */
$cards.find('.list__button').on('click', (evt) => {
	const currentLink = $(evt.currentTarget);
	const cardNum = currentLink.closest('.list__content').find('.list__num').text();

	ga('send', 'event', 'cards', 'full open click', `${cardNum}`);
});

/* Клик по соц стям в cards */
$('.cards [data-social]').on('click', (evt) => {
	let socialName = $(evt.currentTarget).attr('data-social');

	ga('send', 'event', 'share', 'card share', socialName);
});

/* Клик по соц стям в статьях */
$('.article [data-social]').on('click', (evt) => {
	let socialName = $(evt.currentTarget).attr('data-social');

	ga('send', 'event', 'share', 'article share', socialName);
});

/* Клик по кнопку отправить форму в статьях */
$('.article .article-form__btn').on('click', (evt) => {
	let wrapper = $(evt.currentTarget).closest('.page.article');
	let name = clearText($(wrapper).find('.article__title b').text());
	ga('send', 'event', 'form', 'send click', name);
});

/* Клик по баннеру */
$banners.on('click', (evt) => {
	const currentBanner = $(evt.currentTarget);
	const bannerType = currentBanner.data('box');

	let bannerName = currentBanner.attr('alt');

	ga('send', 'event', 'client link', 'banner click', `${bannerType} banner - ${bannerName}`);
	ga('rbcspec.send', 'event', 'client link', 'click');
});

// HEADER

/* Клик по лого RBC в шапке*/
$('.header__logo').on('click', () => {
	ga('send', 'event', 'nav', 'rbc logo');
});

$('.header__partner').on('click', () => {
	ga('send', 'event', 'client link', 'logo header');
	ga('rbcspec.send', 'event', 'client link', 'click');
});

/* Клик по анонсам на статьях */
$('.article .anounce').on('click', (evt) => {
	const $currentTarget = $(evt.currentTarget);

	const $anounceTitle = $currentTarget.find('.anounce__title').text();

	ga('send', 'event', 'article', 'see also bottom', $anounceTitle);
});

/* Клик по блокам "Читайте также" */
$('.cards .preview').on('click', () => {
	ga('send', 'event', 'cards', 'go to reviews');
});

/* Клик по соц. сетям в футере */
$('.footer [data-social]').on('click', (evt) => {
	let socialName = $(evt.currentTarget).attr('data-social');

	ga('send', 'event', 'share', 'project share', socialName);
});
